import React from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';

import FactorySettingsPage from '../components/factory/FactorySettingsPage';
import FactoryBoxResetPage from '../components/factory/FactoryBoxUnregisterPage';

const RouterFactory = () => (
  <Router>
    <Switch>
      <Route path="/factoryReset">
        <FactoryBoxResetPage />
      </Route>
      <Route path="/">
        <FactorySettingsPage />
      </Route>
      <Route render={() => (<div> Sorry, this page does not exist. </div>)} />
    </Switch>
  </Router>
);

export default RouterFactory;



// WEBPACK FOOTER //
// ./src/router/routerFactory.js